import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $(window).on('resize',function(){
        $('.img-on-pattern-container').each(function(){
            $(this).css('min-height',$(this).find('.px-img-on-pattern').outerHeight());
        })
        $('.px-img-on-pattern img,.section-image-2col__foreground img').each(function(){
            var height = $(this).attr("height");
            var width = $(this).attr("width");
            var ratioLimit = 0.3;
            var sizediff = width*ratioLimit;
            //var lowratio = 1-ratioLimit;
            var highlimit = parseInt(height)+parseInt(sizediff);
            var lowlimit = height-sizediff;
            //console.log(width + ' ' + highratio + ' ' + highlimit + ' ' + lowratio + ' ' + lowlimit)
            console.log(width + ' '  + highlimit + ' ' + lowlimit)
            if(width<highlimit && width>lowlimit){
                $(this).addClass('is-square-image');
            }else{
                $(this).removeClass('is-square-image');
            }
        })
    }).trigger('resize')
})